/**
 * GitLab Pipeline Component Factory
 * 为 PatternFly Topology 注册组件类型
 */

import type { ComponentType } from 'react';
import {
  ComponentFactory,
  DagreLayout,
  Graph,
  GraphComponent,
  GraphElement,
  LayoutFactory,
  ModelKind,
  TaskEdge,
  withPanZoom,
} from '@patternfly/react-topology';
import { PipelineLayout } from './gitlab-topology-const';
import GitLabJobNode from './GitLabJobNode';

export const layoutFactory: LayoutFactory = (type: string, graph: Graph) => {
  switch (type) {
    case PipelineLayout.DAGRE:
      return new DagreLayout(graph, {
        rankdir: 'LR', // Left to Right (横向布局)
        nodesep: 25,
        ranksep: 100,
        edgesep: 25,
      });
    default:
      return undefined;
  }
};

const gitlabComponentFactory: ComponentFactory = (
  kind: ModelKind,
  type: string,
): ComponentType<{ element: GraphElement }> | undefined => {
  if (kind === ModelKind.graph) {
    return withPanZoom()(GraphComponent) as ComponentType<{
      element: GraphElement;
    }>;
  }
  if (kind === ModelKind.edge) {
    return TaskEdge as ComponentType<{ element: GraphElement }>;
  }
  if (kind === ModelKind.node) {
    switch (type) {
      case 'task':
        return GitLabJobNode as ComponentType<any>;
      case 'edge':
        return TaskEdge as ComponentType<{ element: GraphElement }>;
      default:
        return undefined;
    }
  }
  return undefined;
};

export default gitlabComponentFactory;

